var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevertForProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3076_2662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 0H2V29H31V0Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41602 7.85425H28.5827V22.3542H4.41602V7.85425Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41602 12.6876C7.08539 12.6876 9.24935 10.5236 9.24935 7.85425H4.41602V12.6876Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41602 17.5208C7.08539 17.5208 9.24935 19.6847 9.24935 22.3541H4.41602V17.5208Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5833 17.5208V22.3541H23.75C23.75 19.6847 25.9139 17.5208 28.5833 17.5208Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5833 12.6876C25.9139 12.6876 23.75 10.5236 23.75 7.85425H28.5833V12.6876Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4993 18.7292C18.1677 18.7292 19.5202 17.1063 19.5202 15.1042C19.5202 13.1022 18.1677 11.4792 16.4993 11.4792C14.831 11.4792 13.4785 13.1022 13.4785 15.1042C13.4785 17.1063 14.831 18.7292 16.4993 18.7292Z",
    stroke: "#0E2483",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 20.5,
    r: 5.5,
    fill: "white",
    stroke: "#0E2483",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3076_2662)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2085 21.5417C7.2085 21.9559 7.54428 22.2917 7.9585 22.2917C8.37271 22.2917 8.7085 21.9559 8.7085 21.5417V19.0417V18.2917H7.9585H5.4585C5.04428 18.2917 4.7085 18.6275 4.7085 19.0417C4.7085 19.4559 5.04428 19.7917 5.4585 19.7917H6.147L4.51069 21.428C4.21779 21.7209 4.21779 22.1958 4.51069 22.4887C4.80358 22.7816 5.27845 22.7816 5.57135 22.4887L7.2085 20.8515V21.5417Z",
    fill: "#0E2483"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3076_2662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3076_2662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "white",
    transform: "translate(4 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevertForProcessing);
export default __webpack_public_path__ + "static/media/revert-for-processing.e167cb33fd3db0d89a0a06dd758c48b8.svg";
export { ForwardRef as ReactComponent };